import { useState } from 'react';

import { AppointmentSearch } from '../booking.types';

export const useTimeslotChunksIndex = (): {
  index: number;
  handleNext: (chunksWithAvailableSlots: AppointmentSearch[][]) => void;
  handlePrev: () => void;
  goToNextAvailable: (foundIndexFromFilteredChunks: number) => void;
  goToChunk: (filtered: AppointmentSearch[][]) => (date: string) => void;
  resetIndex: () => void;
} => {
  const [index, setIndex] = useState(0);

  const handleNext = (chunksWithAvailableSlots: []) =>
    setIndex((current) => {
      if (current < chunksWithAvailableSlots.length - 1) {
        return current + 1;
      }

      return current;
    });

  const handlePrev = () =>
    setIndex((current) => {
      if (current > 0) {
        return current - 1;
      }

      return current;
    });

  const goToNextAvailable = (foundIndexFromFilteredChunks: number) => {
    setIndex((current) => {
      // Todo: check if more logic is needed
      if (current === 0) {
        return foundIndexFromFilteredChunks;
      }
      return current;
    });
  };

  const goToChunk = (filtered: AppointmentSearch[][]) => (date: string) => {
    const formattedDate = date.split('-').join('');
    const foundChunkIndex = filtered.findIndex((x) => x.some((x) => x.day === formattedDate));
    setIndex(foundChunkIndex);
  };

  const resetIndex = () => setIndex(0);

  return {
    index,
    handleNext,
    handlePrev,
    goToNextAvailable,
    goToChunk,
    resetIndex,
  };
};
